/** `FloorPlanModal` / `DocumentFloorPlanVertical`·`DocumentFloorPlanHorizontal`과 동일 — Column: 단(열)별 세로 쌓기 · Row: 작품별 한 줄씩 순서대로 아래로 */
export type FloorPlanCaptionLayout = 'column' | 'row';

export interface FloorPlanA4PreviewProps {
  logoSrc: string;
  title: string;
  subtitle: string;
  date: string;
  imageSrc: string;
  gallery: string;
  location: string;
  pageNumberLabel: string;
  captionLayout: FloorPlanCaptionLayout;
  /** Column이면 열별 블록 수 · Row 면 줄 수=작품 수(블록 한 줄당 1작품). 세로 시트 Column은 단당 최대 5·최대 4열, 가로 시트 Column은 단당 최대 7·최대 3열(`floorPlanCaptionLimits`). */
  captionSegmentCounts: number[];
  onFloorImageFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/** 세로/가로 미리보기가 동시에 마운트될 경우를 피하기 위한 분리된 file input id */
export const FLOOR_PLAN_A4_PREVIEW_INPUT_IDS = {
  vertical: 'floor-plan-floor-image-input-vertical',
  horizontal: 'floor-plan-floor-image-input-horizontal',
} as const;
